import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";

const LOCALES = ["es", "en"] as const;

export function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <div className="flex items-center gap-1">
      {LOCALES.map((lng) => (
        <Button
          key={lng}
          type="button"
          variant={current === lng ? "default" : "outline"}
          size="sm"
          onClick={() => {
            void i18n.changeLanguage(lng);
            try {
              localStorage.setItem("dojomgt.locale", lng);
            } catch {
              // localStorage unavailable (private mode, etc.) — ignore
            }
          }}
        >
          {lng.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
